export const Account = ({ scale = 1 }: { scale?: number }) => {
  return (
    <svg
      width={16 * scale}
      height={16 * scale}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 6.5C9.38071 6.5 10.5 5.38071 10.5 4C10.5 2.61929 9.38071 1.5 8 1.5C6.61929 1.5 5.5 2.61929 5.5 4C5.5 5.38071 6.61929 6.5 8 6.5Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8891 10.6109C12.9205 11.6424 13.5 13.0413 13.5 14.5H2.5C2.5 13.0413 3.07946 11.6424 4.11091 10.6109C5.14236 9.57946 6.54131 9 8 9C9.45869 9 10.8576 9.57946 11.8891 10.6109Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
